import schoolImg from 'assets/images/SchoolImag.png';
import React from 'react';
import { LeftSideWrapper, LogoImage, SchoolImage } from './Theme';

export const LeftSide = ({
    background = schoolImg,
    description = '',
}) => {
    const Logo = localStorage.getItem('logoImgSchool');

    return (
        <LeftSideWrapper>
            <LogoImage src={Logo} alt='Logo' />
            <SchoolImage src={background} alt='notFound' />
        </LeftSideWrapper>
    );
};

